// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"6343":"Canvas","7789":"LoginPage"}[chunkId] || chunkId) + "." + {"353":"ba87be81","2203":"0c6f3644","2483":"e8af4eaf","3862":"af3fc71f","4812":"d16bc873","4925":"acc5f244","6343":"f703aee2","7678":"112a3770","7789":"e2fea33a","9337":"f5d83aef"}[chunkId] + ".chunk.css";
};